import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/cajou";
export default function SecteurCajou() { return <SectorLayout data={data} />; }
